var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisualLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_79",
    "data-name": "\\uADF8\\uB8F9 79",
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.807,
    height: 185.484,
    viewBox: "0 0 202.807 185.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M1191.662,702.789c-6.965-6.965-18.677-7.907-32.118-3.808.081-7.254-1.919-13.4-6.24-17.724-14.375-14.375-48.964-3.093-77.256,25.2s-39.575,62.881-25.2,77.256c6.965,6.966,18.677,7.907,32.118,3.808-.081,7.254,1.919,13.4,6.24,17.724,14.375,14.375,48.964,3.093,77.256-25.2S1206.038,717.164,1191.662,702.789Z",
    transform: "translate(-995.101 -626.006)",
    fill: "#ecdf19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_5",
    "data-name": "\\uD0C0\\uC6D0 5",
    transform: "translate(0 102.135) rotate(-45)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.221,
    cy: 36.694,
    rx: 72.221,
    ry: 36.694,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.221,
    cy: 36.694,
    rx: 71.721,
    ry: 36.194,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualLogo);
export default __webpack_public_path__ + "static/media/visual_logo.731e430858d09b9f8ed7172bdda9e951.svg";
export { ForwardRef as ReactComponent };